// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"wn_a bie_b"};